import { RequestProps } from '../../store/types'
import React, { Dispatch, SetStateAction, useState } from 'react'
import FilterMenu from './FilterMenu'
import CollapsibleSection from '../Button/CollapsibleSection'
import { t } from 'i18next'
import { useGetAllGroupsQuery } from '../../store/redux/reducers/dictionarySlice'
import { FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { isEqual } from 'lodash'
import { useLeftPadding } from '../../store/redux/hooks'
import GroupOptionWithTooltip from '../Tooltip/GroupOptionWithTooltip'

type FilterDictionariesProps = {
  requestProps: RequestProps
  setRequestProps: React.Dispatch<React.SetStateAction<RequestProps>>
  setPage: Dispatch<SetStateAction<number>>
}

function remove<T>(value: T, array: T[]): T[] {
  return array.filter(e => e !== value)
}

const FilterDictionariesMenu = ({ requestProps, setRequestProps, setPage }: FilterDictionariesProps) => {
  const leftPadding = useLeftPadding()
  const [selectedGroups, setSelectedGroups] = useState<string[]>([])
  const { data: groupsResponse } = useGetAllGroupsQuery({})
  const [inactive, setInactive] = useState<boolean | null>(null)

  const handleGroupChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target

    if (checked) {
      setSelectedGroups([...selectedGroups, value])
    } else {
      setSelectedGroups(remove(value, selectedGroups))
    }
  }

  const handleFiltering = () => {
    let newProps: RequestProps = { ...requestProps, page: 0 }

    if (selectedGroups.length !== 0) {
      newProps = { ...newProps, group: selectedGroups.toString() }
    } else {
      newProps = { ...newProps, group: undefined }
    }

    newProps = { ...newProps, inactive: inactive ? inactive : undefined }

    if (isEqual(requestProps, newProps)) return
    setRequestProps(newProps)
    setPage(0)
  }

  const handleClear = () => {
    setSelectedGroups([])
    setInactive(null)
    setPage(0)
    setRequestProps({
      page: 0,
      size: requestProps.size,
      'query:value,key,group': requestProps['query:value,key,group'],
    })
  }

  return (
    <FilterMenu filter={handleFiltering} clear={handleClear}>
      <CollapsibleSection text={t('page.dictionarySettings.table.filters.groups')}>
        {groupsResponse &&
          groupsResponse.map((group: string) => (
            <GroupOptionWithTooltip
              key={group}
              group={group}
              selectedGroups={selectedGroups}
              handleGroupChange={handleGroupChange}
            />
          ))}
      </CollapsibleSection>
      <CollapsibleSection text={t('page.dictionarySettings.table.filters.inactive')}>
        <RadioGroup value={inactive} onChange={(_, value) => setInactive(value === 'true')}>
          <FormControlLabel sx={{ pl: leftPadding }} value={true} control={<Radio />} label={t('page.demands.yes')} />
          <FormControlLabel sx={{ pl: leftPadding }} value={false} control={<Radio />} label={t('page.demands.no')} />
        </RadioGroup>
      </CollapsibleSection>
    </FilterMenu>
  )
}

export default FilterDictionariesMenu